var chunkToChildrenMap = {
	"1003": [
		6489,
		2107,
		390,
		4482
	],
	"1189": [
		6489,
		2107,
		390,
		4482
	],
	"5383": [
		6489,
		2107,
		390,
		4482
	],
	"6642": [
		6489,
		2107,
		390,
		4482
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));